import { Button } from 'src/components';
import { useOnboardingContext } from '../context';
import styles from '../styles.module.scss';

type StepBarProps = {
  onGoToPreviousStep: () => void;
  onGoToNextStep: () => void;
  loadingNextStep?: boolean;
  loadingPreviousStep?: boolean;
  hasUnsavedChanges?: boolean;
  nextLabel?: string;
  hideNextButton?: boolean;
};

const StepBar = ({
  onGoToNextStep,
  onGoToPreviousStep,
  loadingNextStep,
  loadingPreviousStep,
  hasUnsavedChanges,
  nextLabel,
  hideNextButton,
}: StepBarProps) => {
  const { currentStep, totalSteps, isFirstStep, isLastStep, goToNextStep, skippable, steps } =
    useOnboardingContext();

  const defaultNextLabel = isLastStep ? 'Save and finish' : 'Save and continue';

  return (
    <nav className={styles.stepBar}>
      <div>
        <Button
          mode="tertiary"
          size="small"
          onClick={onGoToPreviousStep}
          disabled={isFirstStep}
          loading={loadingPreviousStep}
        >
          Previous Step
        </Button>
      </div>

      <div className={styles.stepper}>
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          return (
            <div
              key={step.title}
              className={`${styles.stepIndicator} ${isActive ? styles.active : ''} ${isCompleted ? styles.completed : ''}`}
            >
              <div className={styles.stepDot}>
                {isCompleted ? (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6L5 9L10 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                ) : (
                  <span>{stepNumber}</span>
                )}
              </div>
              <span className={styles.stepLabel}>{step.title}</span>
            </div>
          );
        })}
      </div>

      <div>
        {skippable && (
          <Button mode="tertiary" size="small" onClick={goToNextStep}>
            Skip this step
          </Button>
        )}
        {!hideNextButton && (
          <Button size="small" onClick={onGoToNextStep} loading={loadingNextStep} disabled={!hasUnsavedChanges}>
            {nextLabel || defaultNextLabel}
          </Button>
        )}
      </div>
    </nav>
  );
};

export default StepBar;
